import './location-selector.scss'

import { reactiveVueMixin } from '@skinsoft/reactive-vue';
import { BModal } from 'bootstrap-vue';
import { defineComponent } from 'vue';
import { LocationSelector } from '../location-selector';

export const LocationSelectorPopup = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sLocationSelector: LocationSelector
    },
    props: [''],
    template: require('./location-selector-popup.html'),
    data() {
        return {
            location: null as any,
        }
    },
    methods: {
        open() {
            (this.$refs.modal as BModal).show();
        },
        onLocationSelected(locationChangeEvent) {
            this.location = locationChangeEvent.location;
        },
        validateLocation() {
            this.$emit("location-validated", { location: this.location });
            (this.$refs.modal as BModal).hide();
        },
    },
})
